@if (items?.length || 0) {
    <div class="nw-navigation-bar-carousel__container">
        @if ((items?.length || 0) > 1) {
            <button
                nw-icon-button
                color="dark"
                class="nw-navigation-bar-carousel__container__button"
                (click)="previousItem()"
                data-test="navigation-bar-carousel-previous"
                aria-label="Previous carousel item"
            >
                <nw-icon icon="chevron-left"></nw-icon>
            </button>
        }
        <div class="nw-navigation-bar-carousel__container__item-wrapper">
            @if (items?.length) {
                @for (item of items; track item.label; let index = $index) {
                    <div
                        class="nw-navigation-bar-carousel__container__item-wrapper__item"
                        [class.nw-navigation-bar-carousel__container__item-wrapper__item--fade-in]="
                            selectedIndex$$() === index
                        "
                        [class.nw-navigation-bar-carousel__container__item-wrapper__item--fade-out]="
                            selectedIndex$$() !== index
                        "
                    >
                        @if (item.icon) {
                            <nw-icon
                                [icon]="item.icon"
                                class="nw-navigation-bar-carousel__container__item-wrapper__item__icon"
                                [style.color]="item.color ?? '#fff'"
                            ></nw-icon>
                        }
                        <a
                            nw-link
                            [href]="item.path"
                            [style.textDecorationColor]="item.color ?? undefined"
                            [style.backgroundColor]="
                                hover && item.color ? item.color : undefined
                            "
                            (mouseenter)="hover = true"
                            (mouseleave)="hover = false"
                            >{{ item.label }}</a
                        >
                    </div>
                }
            } @else {}
        </div>
        @if ((items?.length || 0) > 1) {
            <button
                nw-icon-button
                color="dark"
                class="nw-navigation-bar-carousel__container__button"
                (click)="nextItem()"
                data-test="navigation-bar-carousel-next"
                aria-label="Next carousel item"
            >
                <nw-icon icon="chevron-right"></nw-icon>
            </button>
        }
    </div>
}
